import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Instagram, Facebook, Twitter } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_beauty-hub-manage/artifacts/mwvrate5_image.png";

export default function MpFooter() {
  const { lang } = useLanguage();
  const isAr = lang === "ar";
  return (
    <footer className="mp-footer" data-testid="mp-footer">
      <div className="mp-container grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="bg-white rounded-lg p-2 inline-block">
            <img src={LOGO} alt="iSaloon" className="h-12 object-contain" />
          </div>
          <p className="text-sm mt-3 leading-relaxed opacity-70 max-w-xs">
            {isAr ? "احجز جلسات التجميل والعناية في أفضل الصالونات حول قطر." : "Book beauty & wellness appointments in the best venues across Qatar."}
          </p>
          <div className="flex gap-3 mt-4">
            <a href="#" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="#" aria-label="Facebook"><Facebook size={18} /></a>
            <a href="#" aria-label="Twitter"><Twitter size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-white text-sm mb-3">{isAr ? "للعملاء" : "For customers"}</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/m">{isAr ? "اكتشف الصالونات" : "Discover venues"}</a></li>
            <li><a href="/m?cat=hair">{isAr ? "الشعر" : "Hair"}</a></li>
            <li><a href="/m?cat=nails">{isAr ? "الأظافر" : "Nails"}</a></li>
            <li><a href="/m?cat=spa">{isAr ? "سبا" : "Spa"}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white text-sm mb-3">{isAr ? "للأعمال" : "For business"}</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/marketplace/listing">{isAr ? "اعرض صالونك" : "List your business"}</a></li>
            <li><a href="/login">{isAr ? "تسجيل دخول" : "Log in"}</a></li>
            <li><a href="/signup">{isAr ? "إنشاء حساب" : "Sign up"}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white text-sm mb-3">{isAr ? "الشركة" : "Company"}</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#">{isAr ? "من نحن" : "About"}</a></li>
            <li><a href="#">{isAr ? "تواصل معنا" : "Contact"}</a></li>
            <li><a href="#">{isAr ? "الأحكام" : "Terms"}</a></li>
            <li><a href="#">{isAr ? "الخصوصية" : "Privacy"}</a></li>
          </ul>
        </div>
      </div>

      <div className="mp-container mt-12 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-2 text-xs opacity-60">
        <div>© {new Date().getFullYear()} iSaloon · Maham Group</div>
        <div>{isAr ? "صُنع بكل حب في قطر" : "Made with love in Qatar"}</div>
      </div>
    </footer>
  );
}
